import { createSlice } from '@reduxjs/toolkit';

const initialState = '' as string;

export const pageSlice = createSlice({
  name: 'page',
  initialState,
  reducers: {
    setValue: (state, action) => {
      state = action.payload;
    },
  },
});

export const { setValue } = pageSlice.actions;

export default pageSlice.reducer;
